import { useState } from "react";
import { toast } from 'react-toastify';
import getFileStyleByExtension from "../../utils/IconFile";

export function AttachmentItem({ filename, service }) {
    const FileDownload = require('js-file-download');
    const [imageUrl, setImageUrl] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const fileName = typeof filename === 'string' && filename.includes('$$')
        ? filename.split('$$')[0]
        : filename || 'Arquivo sem nome';


    const isImage = (image) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'ico', 'raw', 'bmp', 'heic'];
        const extension = image?.split('.').pop()?.toLowerCase();
        return imageExtensions.includes(extension);
    };

    const fileDownload = async () => {
        try {
            const response = await service.downloadFile(filename);
            FileDownload(response.data, fileName);
        } catch (error) {
            toast.error(error.message);
        }
    };

    const viewImage = async () => {
        try {
            const response = await service.getAttachments(filename, { responseType: 'blob' });
            const contentType = response.headers['content-type'] || 'image/jpeg';
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            setImageUrl(url);
            setShowModal(true);
        } catch (error) {
            toast.error(error.message);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        URL.revokeObjectURL(imageUrl);
        setImageUrl(null);
    };

    const isImg = isImage(fileName);
    const { icon, color } = getFileStyleByExtension(fileName);
  
    return (
        <>
            <div className="flex items-center justify-between p-3 border border-gray-200 rounded-lg mb-2">
                <div className="flex items-center">
                    <i className={`fas ${icon} ${color} mr-3`} />
                    <p className="text-sm font-medium text-gray-800 truncate max-w-[180px]">
                        {fileName}
                    </p>
                </div>
                <div className="flex space-x-1 ml-4">
                    {isImg && (
                        <button className="text-indigo-600 hover:text-indigo-800" onClick={viewImage}>
                            <i className="fas fa-eye" />
                        </button>
                    )}
                    <button className="text-indigo-600 hover:text-indigo-800" onClick={fileDownload}>
                        <i className="fas fa-download" />
                    </button>
                </div>
            </div>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg relative">
                        <button onClick={closeModal} className="absolute top-2 right-2 text-gray-600 hover:text-red-600">
                            <i className="fas fa-times" />
                        </button>
                        <img src={imageUrl} alt="Visualização" className="max-h-[80vh] w-full object-contain rounded" />
                    </div>
                </div>
            )}
        </>
    );
}  